module.exports = __webpack_public_path__ + "assets/icon-rounded-important-component.b35e1ad2.svg";